const actionTypes = {
  RECEIVE_COURSE_ENROLLMENTS:
    "seneca/enrollments/courses/RECEIVE_COURSE_ENROLLMENTS",
  SAVE_NEW_COURSE_ENROLLMENT:
    "seneca/enrollments/courses/SAVE_NEW_COURSE_ENROLLMENT",
  DELETE_COURSE_ENROLLMENT:
    "seneca/enrollments/courses/DELETE_COURSE_ENROLLMENT"
};

export default actionTypes;
